// Pop-up slot tags (snippets/popup-slots.liquid; Sean, 20 Oct 2026).
// "At Capacity" when a pop-up has no appointment left, "N Slots Remaining"
// under four. Infinity counts Calendly's open times hourly and answers them
// at /apps/fit/popups (the app proxy). The answer is kept for ten minutes in
// sessionStorage so moving between pages asks once. Any failure leaves every
// tag hidden.
(() => {
  const tags = document.querySelectorAll('[data-popup-slots]');
  if (!tags.length) return;

  const KEY = 'td-popup-slots';
  const KEEP_MS = 10 * 60 * 1000;
  // Infinity's normalise(): the join key its cron uses.
  const norm = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const label = (n) => (n === 0 ? 'At Capacity' : n < 4 ? `${n} Slot${n === 1 ? '' : 's'} Remaining` : '');

  const paint = (popups) => {
    const open = new Map();
    for (const p of popups) {
      if (p && Number.isInteger(p.remaining)) open.set(`${norm(p.city)}|${p.start}`, p.remaining);
    }
    for (const tag of tags) {
      const n = open.get(`${norm(tag.dataset.city)}|${tag.dataset.start}`);
      const text = n === undefined ? '' : label(n);
      if (!text) continue;
      tag.textContent = text;
      tag.toggleAttribute('data-full', n === 0);
      tag.hidden = false;
    }
  };

  try {
    const kept = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (kept && Date.now() - kept.at < KEEP_MS && Array.isArray(kept.popups)) {
      paint(kept.popups);
      return;
    }
  } catch {}

  fetch('/apps/fit/popups', { headers: { Accept: 'application/json' } })
    .then((res) => (res.ok ? res.json() : null))
    .then((body) => {
      if (!body || !Array.isArray(body.popups)) return;
      try {
        sessionStorage.setItem(KEY, JSON.stringify({ at: Date.now(), popups: body.popups }));
      } catch {}
      paint(body.popups);
    })
    .catch(() => {});
})();
